import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';

export default class DocumentTemplateDto extends BaseAgencyScopeEntityDto {
    status = 0;
    name: string;
    template: string;
}